// src/services/api.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://api.cettosystem.com.br'; // fallback para dev local

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json', // ou 'application/x-www-form-urlencoded' se precisar
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Senha trocada em outro aparelho (out/26): o servidor recusa o login antigo
// com esta frase (auth.usuario_do_token). Sai da conta e volta pro login com
// o aviso, em vez de cada tela mostrar um erro diferente. Só esta frase —
// os outros 401 seguem como cada tela já trata.
const SENHA_TROCADA = 'Sua senha foi alterada. Entre de novo.';
api.interceptors.response.use(
  (resp) => resp,
  (error) => {
    if (error?.response?.status === 401 && error.response.data?.detail === SENHA_TROCADA) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      if (!['/login', '/recuperar-senha'].includes(window.location.pathname)) {
        window.location.assign('/login?motivo=senha');
      }
    }
    return Promise.reject(error);
  }
);

export default api;